import React from 'react';
import './TermsPage.css';

const TermsPage = () => {
    return (
      <div className="terms-container">
        <h1 className="terms-title">תקנון האתר – BuyTaxi</h1>
        <p className="terms-updated">עודכן בתאריך: 2 באפריל 2025</p>
  
        <h2 className="terms-section-title">1. כללי</h2>
        <p className="terms-text">
          אתר BuyTaxi (להלן: "האתר") מופעל ומנוהל על ידי צוות BuyTaxi ומהווה פלטפורמה דיגיטלית ייעודית לפרסום מודעות למכירה, השכרה או העברה של מוניות. מטרת האתר היא לאפשר לבעלי מוניות ולמתעניינים בתחום ליצור קשר ולבצע עסקאות, וזאת באמצעות ממשק נגיש, נוח ושקוף. השימוש באתר כפוף לתנאים המפורטים בתקנון זה ומהווה הסכמה מפורשת ומלאה מצד כל משתמש לתנאים אלו. אי הסכמה לאחד או יותר מהתנאים, תמנע מהמשתמש את הזכות לעשות שימוש באתר.
        </p>
  
        <h2 className="terms-section-title">2. תנאי גישה ושימוש באתר</h2>
        <p className="terms-text">
          השימוש באתר פתוח וזמין לכלל הציבור ואינו מצריך רישום מקדים או יצירת חשבון משתמש. עם זאת, כדי לשמור על תקינות הפלטפורמה, האתר שומר לעצמו את הזכות לחסום גישה למשתמשים המפרים את תנאי השימוש, מבצעים פעילות לא חוקית או מפרים את תקנות האתר.
          להסרת מודעה או מידע הקשור למונית שפורסמה, יש ליצור קשר ישיר עם צוות האתר באמצעות פרטי ההתקשרות המופיעים בסעיף 6.
        </p>
  
        <h2 className="terms-section-title">3. אחריות ומגבלות</h2>
        <p className="terms-text">
          האתר פועל כמתווך טכנולוגי בלבד ואינו צד לעסקאות הנרקמות בין המפרסמים לבין הגולשים או הרוכשים. BuyTaxi אינו אחראי בשום אופן על טיב המוניות, תקינותן, התאמתן לצרכי המשתמשים או כל פרט אחר הקשור לתוכן המודעות. כל עסקה שתבוצע בעקבות מידע מהאתר תתבצע באחריותם הבלעדית של הצדדים המעורבים.
        </p>
  
        <h2 className="terms-section-title">4. מחירים והיבטים מסחריים</h2>
        <p className="terms-text">
          המחירים המוצגים באתר במסגרת מודעות הפרסום הינם באחריות הבלעדית של מפרסמי המודעות – בעלי המוניות או מי מטעמם. האתר אינו מתערב בקביעת המחירים, בתנאי העסקה או בניהול המשא ומתן בין הצדדים.
          יודגש כי כל המחירים המוצגים באתר הינם <strong>ללא מע"מ</strong>, אלא אם נאמר אחרת באופן מפורש וברור במסגרת המודעה.
          האתר אינו אחראי להצלחת העסקה, למציאת קונה או שוכר או להשגת כל מטרה מסחרית אחרת. אין לראות באתר גורם מתחייב, ערב או אחראי לביצוע פעולות מסחריות כלשהן.
        </p>
  
        <h2 className="terms-section-title">5. תוכן האתר והגבלת אחריות</h2>
        <p className="terms-text">
          המידע והתכנים המופיעים באתר, לרבות מודעות, כתבות, מאמרים, עדכונים וחדשות – ניתנים כשירות למשתמש בלבד, ואינם מהווים ייעוץ מקצועי, משפטי, כלכלי או אחר. כל החלטה המתקבלת בהתבסס על מידע זה הינה באחריות המשתמש בלבד.
          התכנים המפורסמים במדורים כגון "מגזין" או "בלוג המוניות" נוצרים בעזרת מערכות בינה מלאכותית (AI) ואינם נכתבים או נערכים על ידי בני אדם. לפיכך, יתכנו טעויות, חוסרים, אי דיוקים או תכנים שאינם רלוונטיים – והאתר אינו אחראי לאף אחד מאלה.
        </p>
  
        <h2 className="terms-section-title">6. יצירת קשר</h2>
        <p className="terms-text">
          כל פנייה בנוגע להסרת מודעה, עדכון מידע, מתן משוב או קבלת מענה לשאלות תיעשה באמצעות אחד מאמצעי הקשר הבאים:
          <br/>
          - כתובת דוא"ל: <strong>amiratiashuri@gmail.com</strong><br/>
          - טלפון ישיר: <strong>050-2268395</strong><br/>
          האתר אינו מתחייב למענה מיידי אך ישאף לתת מענה הולם בתוך זמן סביר.
          <br/><br/>
          ט.ל.ח – טעות לעולם חוזרת. יתכנו שגיאות או אי דיוקים באתר – ואין לראות בהם התחייבות.
        </p>
  
        <h2 className="terms-section-title">7. זכויות יוצרים וקניין רוחני</h2>
        <p className="terms-text">
          כל הזכויות באתר, לרבות עיצוב, קוד, תוכן, סימני מסחר, תמונות, לוגואים, גרפיקה, טקסטים ואיורים – שייכים למפעילי האתר או לצדדים שלישיים אשר העניקו הרשאה מתאימה. אין להעתיק, לשכפל, להפיץ או לפרסם תכנים מהאתר ללא אישור מפורש ובכתב.
        </p>
  
        <h2 className="terms-section-title">8. פרטיות ואבטחת מידע</h2>
        <p className="terms-text">
          האתר שומר על פרטיות המשתמשים ואינו אוסף מידע אישי לצרכים מסחריים. כל מידע שיימסר מיוזמת המשתמש, למשל בפנייה לצוות האתר, יישמר במערכת לצורכי טיפול בלבד ולא יועבר לצדדים שלישיים ללא הסכמה.
        </p>
  
        <h2 className="terms-section-title">9. הדין החל וסמכות שיפוט</h2>
        <p className="terms-text">
          תקנון זה וכל סכסוך משפטי שינבע ממנו או מהשימוש באתר יהיו כפופים לדיני מדינת ישראל בלבד. סמכות השיפוט הבלעדית תהיה לבתי המשפט המוסמכים בעיר תל אביב.
        </p>
  
        <h2 className="terms-section-title">10. עדכונים ושינויים בתקנון</h2>
        <p className="terms-text">
          הנהלת האתר שומרת לעצמה את הזכות לשנות, לעדכן או למחוק סעיפים מתקנון זה בכל עת וללא צורך בהודעה מוקדמת. האחריות להתעדכן בתנאי התקנון חלה על המשתמש בלבד. שימוש באתר לאחר השינוי יהווה הסכמה מחודשת לתנאים המעודכנים.
        </p>
      </div>
    );
  };
  
  export default TermsPage;